module.exports = __webpack_public_path__ + "img/big.0a22a014.jpg";